import React from 'react';
import { Link, TextField, useRecordContext } from 'react-admin';
import { leadsFields } from '../leads.model';
import EmptyField from '@/material/emptyField.component';

const LeadLinkField = (props) => {
  const record = useRecordContext();

  if (!record || !record[leadsFields.id]) {
    return <EmptyField />;
  }

  return (
    <Link to={`${record[leadsFields.id]}/show`}>
      <TextField source={leadsFields.id}  {...props} />
    </Link>
  );
};

export default LeadLinkField;
